import React, { useEffect, useState } from 'react';

const LoadingScreen = ({ onLoadingComplete }) => {
  const [progress, setProgress] = useState(0);
  const [phase, setPhase] = useState('loading');

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setPhase('fading');
          setTimeout(() => {
            onLoadingComplete();
          }, 1000);
          return 100;
        }
        return prev + 2;
      });
    }, 40);

    return () => clearInterval(interval);
  }, [onLoadingComplete]);

  return (
    <div 
      className="fixed inset-0 bg-white z-50 flex items-center justify-center overflow-hidden transition-opacity duration-1000"
      style={{
        opacity: phase === 'fading' ? 0 : 1,
      }}
    >
      {/* Elegant minimal design */}
      <div className="relative text-center">
        {/* Luxury brand style logo */}
        <div className="mb-16">
          <div className="relative inline-block">
            {/* Animated border */}
            <div className="absolute inset-0 -m-8">
              <svg width="200" height="200" className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <rect 
                  x="10" 
                  y="10" 
                  width="180" 
                  height="180" 
                  fill="none" 
                  stroke="#000" 
                  strokeWidth="1"
                  strokeDasharray="720"
                  strokeDashoffset={720 - (progress * 7.2)}
                  style={{ transition: 'stroke-dashoffset 0.3s ease-out' }}
                />
              </svg>
            </div>

            {/* Logo */}
            <img 
              src="/cortexa-logo.jpeg" 
              alt="Cortexa" 
              className="w-32 h-32 object-contain relative z-10"
              style={{
                filter: 'grayscale(100%) contrast(1.2)',
              }}
            />
          </div>
        </div>

        {/* Elegant typography */}
        <div className="space-y-8">
          <h1 
            className="text-3xl tracking-[0.5em] font-light text-black"
            style={{
              fontFamily: 'Georgia, serif',
              letterSpacing: '0.5em'
            }}
          >
            CORTEXA
          </h1>

          {/* Minimalist progress */}
          <div className="w-64 mx-auto">
            <div className="h-px bg-black/10 relative overflow-hidden">
              <div 
                className="absolute left-0 top-0 h-full bg-black transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="mt-4 text-xs tracking-[0.3em] text-black/40 font-light">
              {progress < 30 ? 'PREPARING' : progress < 70 ? 'LOADING' : 'READY'}
            </div>
          </div>
        </div>

        {/* Luxury detail */}
        <div className="mt-16 flex justify-center gap-1">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="w-1 h-1 rounded-full bg-black"
              style={{
                opacity: progress > (i * 33) ? 0.6 : 0.2,
                transition: 'opacity 0.5s ease'
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;